export enum CredentialType {
  QUARTECH = 'Quartech',
  PARKING = 'Parking',
  BIKE = 'Bike',
  ACCESS = 'Access',
  BC = 'British Columbia',
  OTHER = 'Other'
}

export enum CredentialSubType {
  IDENTITY = 'identity',
  MEMBERSHIP = 'membership',
  CERTIFICATE = 'certificate',
  OTHER = 'other'
}

export interface CredentialMetadata {
  name: string;
  type: CredentialType;
  sub_type: CredentialSubType;
  issuer: string;
  description?: string;
}

export interface CredentialCardConfig {
  primaryAction?: {
    title: string;
    action: () => void;
  };
  secondaryAction?: {
    title: string;
    action: () => void;
  };
  showBack?: boolean;
  showDetails?: boolean;
}

export interface CredentialCardBackIssuerDetails {
  name: string;
  type: CredentialType;
  issuer: string;
  issuer_desc: string;
  link: string;
  link_desc: string;
}

export const CARD_BACK_ISSUER_DETAILS: CredentialCardBackIssuerDetails[] = [
  {
    name: 'Quartech',
    type: CredentialType.QUARTECH,
    issuer: 'Quartech',
    issuer_desc:
      'People-centric IT solutions that empower organizations to better serve their communities.',
    link: 'https://www.quartech.com',
    link_desc: 'Quartech website'
  },
  {
    name: 'British Columbia',
    type: CredentialType.BC,
    issuer: 'British Columbia',
    issuer_desc: 'British Columbia is a province in Canada.',
    link: 'https://www.gov.bc.ca',
    link_desc: 'British Columbia government website'
  },
  {
    name: 'Other',
    type: CredentialType.OTHER,
    issuer: 'Other',
    issuer_desc: 'Other is a type of credential.',
    link: 'https://www.other.com',
    link_desc: 'Other website'
  }
];

//TODO: Describe all the details for each credential type
